<template lang="pug"> 
  v-btn( 
    :disabled='loading || disabled'
    :loading='loading'
    :color="colorDefault"
    :block="block"
    :dark="!(loading || disabled)"
    :value="value"
    depressed 
    :large="!xSmall && !small"
    :xSmall="xSmall"
    :small="small"
    tile
    :outlined="outlined"
    :style="roundTop ? 'border-top-right-radius:10px; border-top-left-radius:10px;' : 'border-radius:10px;'"
    @click='$emit("click")'
  ).notranslate
    slot

</template>
<script>
import ButtonMixin from '@/mixins/Button'
export default {
  mixins : [ButtonMixin],
  props: {
    value: {
      type: [String,Object,Number],
      default: null
    },
    roundTop: {
      type:Boolean,
      default:false
    },
    outlined : {
      type:Boolean,
      default:false
    },
  },
  computed: {
    colorDefault () {
      return this.color || 'var(--bg-main-color-2-v2)'
    }
  }
}
</script>